import { HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiProvider } from './helpers/api-provider';
import { ApiProviderFactoryService } from './helpers/api-provider-factory.service';
import { isDesktop, isTablet } from '../../signals/device';

@Injectable({
  providedIn: 'root',
})
export class RedirectorApiService {
  private _apiFactory = inject(ApiProviderFactoryService);

  /**
   * For API communication
   */
  private _api: ApiProvider = this._apiFactory.create({
    defaultOptions: {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'DEVICE-TYPE': isDesktop()
          ? 'Desktop'
          : isTablet()
          ? 'Tablet'
          : 'Mobile',
      }),
      withCredentials: true,
    },
    host: environment.redirector_host,
  });

  public get customHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'DEVICE-TYPE': isDesktop() ? 'Desktop' : isTablet() ? 'Tablet' : 'Mobile'
    });
  }

  public get customHeadersList(): any[] {
    return this._api.customHeadersList;
  }

  /**
   * /site/mirror/list
   * @param params
   */
  public getMirrorOnStage(params: object = {}): Observable<any> {
    return this._api.get(`/site/mirror/list`, params);
  }

  /**
   * /static/img/provider/logo_${:id}.jpeg
   * @param params
   */
  public blockMirror(id, params: object = {}): Observable<any> {
    return this._api.get(`/static/img/provider/logo_${id}.jpeg`, params);
  }

  public checkNewMirror(mirror: string) {
    const _api = this._apiFactory.create({
      defaultOptions: {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'DEVICE-TYPE': isDesktop()
            ? 'Desktop'
            : isTablet()
            ? 'Tablet'
            : 'Mobile',
        }),
        withCredentials: true,
      },
      host: 'https://' + mirror
    });
    return _api.get(`/api/service/environment`, {crossdomain: true});
  }

}
